// @flow

import { type ColombianDocumentType } from './types';
import { stripNonMatching } from '@tectonics/utils/formatting';

export function normalizeDocument(documentType: ColombianDocumentType, document: ?string): string {
  const normalized = document ? stripNonMatching(document, 'numeric') : '';
  return documentType === 'CE'
    ? normalized.substr(0, 7)
    : normalized;
}
